// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {KeyValueList} from '../../key-value-list';

export const FacetOptions = t.struct({
    isLoadingStates: t.Boolean,
    states: KeyValueList
}, {
    defaultProps: {
        isLoadingStates: false,
        states: []
    },
    name: 'DigitalUserFacetOptions',
    strict: true
});
